// Module
var code = "<runner-page-description is-show=\"!isMobile\" page-header-text=\"Setup\" page-description=\"Configure platform features.\" help-link=\"{{$ctrl.helpUri}}\"> </runner-page-description> <runner-setup-tabs></runner-setup-tabs> <setup-features></setup-features> ";
// Exports
export default code;